import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ChassisDocumentImportDialog from '../ChassisDocumentImportDialog'

/**
 * Wrapper component that handles reopening the dialog from notifications
 */
export default function ChassisDocumentImportDialogWrapper({
  open: externalOpen,
  onClose: externalOnClose,
  onComplete,
}) {
  const [open, setOpen] = useState(externalOpen)
  const [resumeBatchId, setResumeBatchId] = useState(null)

  // Sync with external open prop
  // Only sync when externalOpen becomes true (parent wants to open)
  // Don't sync when false to allow notification events to open the dialog independently
  useEffect(() => {
    if (externalOpen) {
      setOpen(true)
      setResumeBatchId(null)
    }
  }, [externalOpen])

  // Listen for notification click events
  useEffect(() => {
    const handleOpenResults = (event) => {
      const { batchId } = event.detail

      // Stop other listeners from being called (prevents duplicate dialogs)
      event.stopImmediatePropagation()

      // Reopen dialog with the batch ID to resume at results step
      setResumeBatchId(batchId)
      setOpen(true)
    }

    // Add listener with capture phase to ensure one instance handles it first
    window.addEventListener(
      'openDocumentImportResults',
      handleOpenResults,
      true
    )

    return () => {
      window.removeEventListener(
        'openDocumentImportResults',
        handleOpenResults,
        true
      )
    }
  }, [])

  const handleClose = () => {
    setOpen(false)
    setResumeBatchId(null)
    if (externalOnClose) {
      externalOnClose()
    }
  }

  return (
    <ChassisDocumentImportDialog
      open={open}
      onClose={handleClose}
      onComplete={onComplete}
      resumeBatchId={resumeBatchId}
    />
  )
}

ChassisDocumentImportDialogWrapper.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onComplete: PropTypes.func,
}
